
import { create } from "zustand";
import { API_BASE_URL, API_BASE_URL1 } from "../../../../Services/baseApiUrl";
import { apiCall } from "../../../../../utils/apiCall";

const RoutepointTransactionStore = create((set, get) => ({

    routeTransactionData: [],
    loading: false,
    error: false,

   fetchRoutepointTransactionReportsApi: async (fromDate, toDate, zoneId, circleId, routeCode, RouteSupervisorId) => {
    set({ loading: true, error: null });
    try {
        const params = new URLSearchParams();

        if (fromDate) params.append("fromDate", fromDate);
        if (toDate) params.append("toDate", toDate);
        if (zoneId) params.append("zoneId", zoneId);
        if (circleId) params.append("wardId", circleId);
        if (routeCode) params.append("routeCode", routeCode);
        if (RouteSupervisorId) params.append("RouteSupervisorId", RouteSupervisorId);

        const url = `${API_BASE_URL1}Routes/GetRawRoutePointReport?${params.toString()}`;

        const reportsData = await apiCall({
            url,
            method: "get",
            token: localStorage.getItem("token"),
        });

        set({
            routeTransactionData: Array.isArray(reportsData) ? reportsData : [],
            loading: false
        });

    } catch (error) {
        console.log(error.response?.data?.message || "Error fetching data");
        if (error.response && error.response.status === 404) {
            set({
                routeTransactionData: [],
                error: "No Data found.",
                loading: false
            });
        } else {
            set({ error: error.response?.data?.message || "Something went wrong", loading: false });
        }
    }
},

}));

export default RoutepointTransactionStore
